import type { GroupedReward } from './rewards.schema';
import { z } from 'zod';
import { ENDPOINTS } from '@/queries/endpoints';
import { httpClient } from '@/queries/httpClient';
import { GroupedRewardSchema } from './rewards.schema';

export const rewardsApi = {
  async claimDailyReward(rewardRuleId?: string) {
    const payload = rewardRuleId ? { rewardRuleId } : { type: 'daily-bonus' as const };
    const response = await httpClient.post(ENDPOINTS.rewards.claimDailyReward, payload);

    return response;
  },
  async getGrouped() {
    const response = await httpClient.get<GroupedReward[]>(ENDPOINTS.rewards.grouped);

    return z.array(GroupedRewardSchema).parse(response);
  },
};
